import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../services/api';

interface PortalSettingsContextType {
  uatVisible:                boolean;
  requirementsTrackerVisible: boolean;
  maintenanceModeEnabled:     boolean;
  loaded:                     boolean;
}

const PortalSettingsContext = createContext<PortalSettingsContextType>({
  uatVisible:                 true,
  requirementsTrackerVisible: true,
  maintenanceModeEnabled:     false,
  loaded:                     false,
});

export function PortalSettingsProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<PortalSettingsContextType>({
    uatVisible: true, requirementsTrackerVisible: true, maintenanceModeEnabled: false, loaded: false,
  });

  useEffect(() => {
    api.portalSettings.get()
      .then(s => setState({
        uatVisible:                 s.UATTestingVisible          !== '0',
        requirementsTrackerVisible: s.RequirementsTrackerVisible !== '0',
        maintenanceModeEnabled:     s.MaintenanceModeEnabled     === '1',
        loaded: true,
      }))
      .catch(() => setState(prev => ({ ...prev, loaded: true })));
  }, []);

  return (
    <PortalSettingsContext.Provider value={state}>
      {children}
    </PortalSettingsContext.Provider>
  );
}

export function usePortalSettings() {
  return useContext(PortalSettingsContext);
}
